import { FormControl, FormGroup, ValidatorFn } from '@angular/forms';

import { ErrorCode } from '@constants/error.constant';
import { SocialRegimeCode } from '@enums/social-regime-code.enum';
import { DateHelper } from '@helpers/date.helper';
import { FormHelper } from '@helpers/form.helper';
import { ErrorMessage } from '@interfaces/error-message';

export type DirectorFormType = {
  socialRegime: FormControl<SocialRegimeCode | null>;
  startJobDate: FormControl<string | null>;
  endJobDate: FormControl<string | null>;
  acre: FormControl<boolean | null>;
  jobCenterRegistrationDate: FormControl<string | null>;
  jobCenterRegistrationDuration: FormControl<number | null>;
  jobCenterRegistrationEndDate: FormControl<string | null>;
};

export class DirectorForm extends FormGroup<DirectorFormType> {
  private static readonly jobCenterRegistrationInvalideDate = 'jobCenterRegistrationInvalideDate';

  get socialRegime(): FormControl<SocialRegimeCode | null> {
    return this.controls.socialRegime;
  }

  get startJobDate(): FormControl<string | null> {
    return this.controls.startJobDate;
  }

  get endJobDate(): FormControl<string | null> {
    return this.controls.endJobDate;
  }

  get endJobDateErrorMessage(): ErrorMessage {
    return FormHelper.getDatePickerErrorMessage(this.endJobDate, {
      checkMin: true,
      minError: ErrorCode.INVALID,
      minErrorMessage: 'La date de fin doit être postérieure à la date de début'
    });
  }

  get acre(): FormControl<boolean | null> {
    return this.controls.acre;
  }

  get jobCenterRegistrationDate(): FormControl<string | null> {
    return this.controls.jobCenterRegistrationDate;
  }

  get jobCenterRegistrationDateErrorMessage(): ErrorMessage | null {
    return FormHelper.simpleErrorMessage(this, {
      simpleErrorCode: DirectorForm.jobCenterRegistrationInvalideDate,
      simpleErrorMessage: 'La date de début de droit ARE doit être antérieur à la date de fin de droit ARE'
    });
  }

  get jobCenterRegistrationDuration(): FormControl<number | null> {
    return this.controls.jobCenterRegistrationDuration;
  }

  get jobCenterRegistrationEndDate(): FormControl<string | null> {
    return this.controls.jobCenterRegistrationEndDate;
  }

  get jobCenterRegistrationEndDateErrorMessage(): ErrorMessage | null {
    return FormHelper.simpleErrorMessage(this, {
      simpleErrorCode: DirectorForm.jobCenterRegistrationInvalideDate,
      simpleErrorMessage: 'La date de fin de droit ARE doit être supérieure à la date de début de droit ARE'
    });
  }

  constructor() {
    super(
      {
        socialRegime: new FormControl<SocialRegimeCode | null>(null),
        startJobDate: new FormControl<string | null>(null),
        endJobDate: new FormControl<string | null>(null),
        acre: new FormControl<boolean | null>(null),
        jobCenterRegistrationDate: new FormControl<string | null>(null),
        jobCenterRegistrationDuration: new FormControl<number | null>(null),
        jobCenterRegistrationEndDate: new FormControl<string | null>(null)
      },
      [DirectorForm.jobCenterRegistrationDateValidator()]
    );
  }

  static jobCenterRegistrationDateValidator(): ValidatorFn {
    return (form: DirectorForm) => {
      if (!form.jobCenterRegistrationDate.value || !form.jobCenterRegistrationEndDate.value) {
        return null;
      }

      return DateHelper.isSameOrAfter(form.jobCenterRegistrationDate.value, form.jobCenterRegistrationEndDate.value)
        ? {
            [DirectorForm.jobCenterRegistrationInvalideDate]: true
          }
        : null;
    };
  }
}
